import { Dispatch } from '@/redux/store';
import { BrandModelType, RootModel } from '@/types';
import { createModel } from '@rematch/core';
import { message } from 'antd';
import produce from 'immer';

const initialState: BrandModelType = {
  loading: false,
  editId: null,
};

export const brands = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setEditId: produce((state, payload) => {
      state.editId = payload;
    }),
    updateLoading: produce((state, payload) => {
      state.loading = payload;
    }),
  },
  effects: (dispatch: Dispatch) => ({
    async getAsync(): Promise<void> {
      this.updateLoading(true);
      try {
        const item = await dispatch.brandEntities.findByUser();
        if (item) {
          this.setEditId(item.id);
        }
      } catch (e) {
        console.error(e);
        message.error(`Failed to get brands`);
      } finally {
        this.updateLoading(false);
      }
    },

    async saveAsync(payload): Promise<void> {
      this.updateLoading(true);
      try {
        const result = await dispatch.brandEntities.save(payload);
        message.success('Save successfully');
        return result;
      } catch (err) {
        console.error(err);
        message.error('Fail to save');
      } finally {
        this.updateLoading(false);
      }
    },
  }),
});
